import { FormEvent, useState } from 'react'
import Seo from '@/components/Seo'
import { createContactMessage } from '@/lib/contact'

function Contact() {
  const [sent, setSent] = useState(false)
  const [sending, setSending] = useState(false)
  const [error, setError] = useState('')

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const form = event.currentTarget
    const data = new FormData(form)
    setSending(true)
    setError('')
    try {
      await createContactMessage({
        name: String(data.get('nombre') || ''),
        email: String(data.get('email') || ''),
        subject: String(data.get('asunto') || ''),
        message: String(data.get('mensaje') || ''),
      })
      setSent(true)
    } catch (err) {
      console.error('No se pudo enviar el mensaje:', err)
      setError('No se pudo enviar el mensaje. Inténtalo de nuevo.')
    } finally {
      setSending(false)
    }
  }

  return (
    <>
      <Seo
        title="Contacto y soporte"
        description="Escribe a HFCursos para soporte de inscripciones, aula y certificados."
      />
      <section className="mx-auto grid max-w-6xl gap-12 px-5 py-12 lg:grid-cols-2 lg:px-8">
        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-[#C41E3A]">Soporte</p>
          <h1 className="mt-3 font-['Fraunces'] text-4xl">Contacto</h1>
          <p className="mt-4 max-w-md text-sm leading-7 text-[#1E3A5F]/70">
            Para inscripciones, acceso al aula o certificados, escribe con tu nombre y el curso. Respondemos en días laborables.
          </p>
          <address className="mt-8 not-italic text-sm leading-7 text-[#1E3A5F]/70">
            HFCursos
            <br />
            Torreón Coahuila, Mexico
            <br />
            
            <br />
            <a className="underline" href="mailto:hidraulica.facil@gmail.com">hidraulica.facil@gmail.com</a>
          </address>
        </div>
        {sent ? (
          <p className="self-center text-sm">Mensaje enviado. Te escribiremos a la brevedad.</p>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <label className="block text-sm">
              Nombre
              <input required name="nombre" className="mt-1 w-full border border-[#1E3A5F]/20 bg-transparent px-3 py-2" />
            </label>
            <label className="block text-sm">
              Correo
              <input required type="email" name="email" className="mt-1 w-full border border-[#1E3A5F]/20 bg-transparent px-3 py-2" />
            </label>
            <label className="block text-sm">
              Curso o asunto
              <input name="asunto" className="mt-1 w-full border border-[#1E3A5F]/20 bg-transparent px-3 py-2" />
            </label>
            <label className="block text-sm">
              Mensaje
              <textarea required name="mensaje" rows={5} className="mt-1 w-full border border-[#1E3A5F]/20 bg-transparent px-3 py-2" />
            </label>
            {error ? <p className="text-sm text-[#C41E3A]">{error}</p> : null}
            <button
              type="submit"
              disabled={sending}
              className="bg-[#1E3A5F] px-5 py-2.5 text-sm text-[#F4EFE6] disabled:opacity-50"
            >
              {sending ? 'Enviando…' : 'Enviar'}
            </button>
          </form>
        )}
      </section>
    </>
  )
}

export default Contact
